<div class="file">
  @if (isImage() && fileCard().fileParams.id) {
    <app-file-card-image
      class="file-card-image"
      [fileId]="fileCard().fileParams.id"
      [imgSize]="imgSize()"
      [needBtn]="false"
      (openPreview)="handleClick('open')"
    />
  } @else {
    <div class="file-container">
      <div class="file-name">
        {{ fileCard().fileParams.filename }}
      </div>
      <div class="file-size">
        {{ fileCard().fileParams.size | formatSize }}
      </div>
    </div>
  }
  <div
    class="action-btns"
    [class]="getActionButtonsClass()"
  >
    @if (fileCard().isEditModeActive) {
      <span
        tabindex="-1"
        class="action-btn action-btn-info"
        [matTooltip]="infoTooltip()"
        matTooltipClass="multiline-tooltip"
      >
        <mat-icon>info</mat-icon>
      </span>
    }
    <button
      mat-mini-fab
      tabindex="-1"
      class="action-btn"
      [class.full-width]="isNeedPreview()"
      (click)="handleClick('download')"
    >
      <mat-icon>download</mat-icon>
    </button>
    @if (fileCard().isEditModeActive) {
      <button
        mat-mini-fab
        tabindex="-1"
        class="action-btn"
        (click)="handleClick('delete')"
      >
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
</div>
@if (isAction()) {
  <app-file-progress-bar-status/>
}
